/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  LEADS_FETCH,
  LEADS_FETCH_SUCCESS,
  LEADS_FETCH_FAILURE
} from 'actions/leadsAction';

import { SIGNOUT } from 'actions/authActions';

const initialState = {
  leads: [],
  count: 0,
  pagination: null,
  counts: null,
};

const LeadsReducer = (state = initialState, action) => {
  switch (action.type) {


    case LEADS_FETCH: {
      const isPaginated = action.meta?.isPaginated;
      return produce(state, (draft) => {
        if (!isPaginated && draft.pagination) return;
        draft.leads = [];
        draft.count = 0;
        draft.pagination = null;
        draft.counts = null;
        draft.loading = true
      });
    }
      break;

    case LEADS_FETCH_SUCCESS: {
      const { leads, pagination, counts } = action.payload;
      const isPaginated = action.meta?.isPaginated;
      // console.log("LeadsReducer: LEADS_FETCH_SUCCESS ", leads, action.payload);

      return produce(state, (draft) => {
        if (!isPaginated && draft.pagination) return;
        draft.leads = leads;
        draft.count = pagination?.total ?? leads?.length;
        draft.pagination = pagination || null;
        draft.counts = counts || null;
        draft.loading = false
      });
    }
      break;

    case LEADS_FETCH_FAILURE: {
      const isPaginated = action.meta?.isPaginated;
      return produce(state, (draft) => {
        if (!isPaginated && draft.pagination) return;
        draft.leads = [];
        draft.count = 0;
        draft.pagination = null;
        draft.counts = null;
        draft.loading = false

      });
    }
      break;

    case SIGNOUT: {
      return produce(state, (draft) => {
        draft.leads = [];
        draft.count = 0;
        draft.pagination = null;
        draft.counts = null;
      });
    }
      break;


    default: {
      return state;
    }
      break;
  }
};

export default LeadsReducer;
